export const packageList = [
  {
    name: 'sys',
    activeRule: [],
  },
  {
    name: 'bss_common',
    activeRule: []
  },
  {
    name: 'bss_ams',
    activeRule: ['ams']
  },
  {
    name: 'bss_uamp',
    activeRule: ['uamp']
  },
  {
    name: 'bss_mcs',
    activeRule: ['mcs']
  },
  {
    name: 'bss_inform_center',
    activeRule: ['inform-center']
  },
  {
    name: 'bss_config',
    activeRule: ['bss-config']
  },
  {
    name: 'bss_flow',
    activeRule: []
  },
  {
    name: 'bss',
    activeRule: ['bss'], // 组件平台
  },
  {
    name: 'bss_opa',
    activeRule: ['opa']
  },
  {
    name: 'devops_flow',
    activeRule: []
  }
]
export const remoteModuleConfig = {
  dev: ['sys', 'bss_common', 'bss_ams', 'bss_uamp', 'bss_mcs', 'bss_inform_center', 'bss_config', 'bss', 'bss_flow', 'bss_opa', 'devops_flow'],
  stg: ['sys', 'bss_common', 'bss_ams', 'bss_uamp', 'bss_mcs', 'bss_inform_center', 'bss_config', 'bss', 'bss_flow', 'bss_opa', 'devops_flow'],
  uat: ['sys', 'bss_common', 'bss_ams', 'bss_uamp', 'bss_mcs', 'bss_inform_center', 'bss_config', 'bss', 'bss_flow', 'bss_opa', 'devops_flow'],
  prd: ['sys', 'bss_common', 'bss_ams', 'bss_uamp', 'bss_mcs', 'bss_inform_center', 'bss_config', 'bss', 'bss_flow', 'bss_opa', 'devops_flow'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/bss/index.js